import { render, staticRenderFns } from "./TeamDetails.vue?vue&type=template&id=6e446e20&scoped=true&"
import script from "./TeamDetails.vue?vue&type=script&lang=js&"
export * from "./TeamDetails.vue?vue&type=script&lang=js&"
import style0 from "./TeamDetails.vue?vue&type=style&index=0&id=6e446e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e446e20",
  null
  
)

export default component.exports